export default "__VITE_ASSET__otv2sio1__"